import EmailVerificationCodeRequest from "interfaces/request/EmailVerificationCodeRequest";
import PhoneVerificationCodeRequest from "interfaces/request/PhoneVerificationCodeRequest";
import { postDataAsync } from "./PortalApi";
import VerificationResponse from "interfaces/response/VerificationResponse";
import VerifyCodeRequest from "interfaces/request/VerifyCodeRequest";
import VerifyCodeResponse from "interfaces/response/VerifyCodeResponse";

export const requestForEmailVerificationCodeAsync = async (
  data: EmailVerificationCodeRequest
) => {
  const routeUrl = "VerificationCode/Email";
  return await postDataAsync<EmailVerificationCodeRequest, VerificationResponse>(
    routeUrl,
    data
  );
};

export const requestForPhoneVerificationCodeAsync = async (
  data: PhoneVerificationCodeRequest
) => {
  const routeUrl = "VerificationCode/Phone";
  return await postDataAsync<PhoneVerificationCodeRequest, VerificationResponse>(
    routeUrl,
    data
  );
};

export const requestToVerifyVerificationCodeAsync = async (
  data: VerifyCodeRequest
) => {
  const routeUrl = "VerificationCode/Verify";
  return await postDataAsync<VerifyCodeRequest, VerifyCodeResponse>(
    routeUrl,
    data
  );
};
